var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('search1',{attrs:{"searchStatus":false,"back":'/home'}}),_c('section',{staticClass:"padding-footer"},[_c('b-container',[_c('utilities-downtime')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }